import React, { useContext, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import useStaticInfo from '../../models/StaticInfo';

const TitleContainer = styled.div`
  background: #fd980f;
  display: flex;
  justify-content: center;
  padding-left: 30px;

  @media (max-width: 670px) {
    padding: 10px 20px 10px 30px;
  }
`;

const TitleDiv = styled.div`
  width: 1024px;
`;

const Title = styled.span`
  color: #fff;
  font-size: 2rem;
  font-weight: 400;
  margin-left: -3px;
  line-height: 80px;
  text-transform: uppercase;

  @media (max-width: 670px) {
    line-height: 40px;
  }
`;

const MainContainer = styled.div`
  background: #dedede;
  justify-content: center;
  display: flex;
`;

const MainWidth = styled.div`
  display: flex;
  background: #fff;
  flex-direction: column;
  padding: 20px 20px 104px 20px;
  width: 1024px;
  box-shadow: 0 0 2px #bbb;

  p {
    font-size: 0.875rem;
    color: #666666;
    margin: 0;
    line-height: 1.5;
  }
`;

const PromoImg = styled.img`
  margin-top: 42px;
  max-width: 100%;
  height: auto;
`;

const Answer = styled.span`
  color: #666666;
  font-size: 14px;
`;

const SubTitle = styled.span`
  color: #ff9429;
  font-size: 20px;
  font-weight: bold;
  margin-top: 40px;
  text-align: center;
  margin-bottom: 17px;
  margin-left: ${(props) => (props.left ? '-3.88px' : '0px')};
`;

const Qusetion = styled.span`
  font-weight: bold;
  color: #000;
  margin-top: 21px;
  font-size: 14px;
`;

const Href = styled.a`
  color: #fd980f;
  &:hover {
    color: #fd980f;
  }
`;

const Margin = styled.div`
  margin-top: ${(props) => props.top};
`;

const CopyRight = () => {
  const { getStaticValue, StaticInfoContext, language } = useStaticInfo('Pages-Copyright');

  const staticInfo = useContext(StaticInfoContext);

  const { name, content, keywords, description } = useMemo(
    () => getStaticValue(['name', 'content', 'keywords', 'description'], staticInfo),
    [staticInfo, language]
  );

  return (
    <div>
      <TitleContainer>
        <TitleDiv>
          <Title>{name}</Title>
        </TitleDiv>
      </TitleContainer>

      <MainContainer>
        <MainWidth dangerouslySetInnerHTML={{ __html: content }} />
      </MainContainer>
    </div>
  );
};
export default withRouter(CopyRight);
